import { DeviceConditionTemplatesSettings } from '@/pages/settings/DeviceConditionTemplatesSettings.js';

export function ConditionsSettingsPage() {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <h2 className="mb-4 text-xl font-bold text-slate-950">Device Conditions</h2>
      <DeviceConditionTemplatesSettings />
    </div>
  );
}
